module.exports = "<svg viewBox=\"0 0 64 64\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Icons/Close\" stroke-width=\"1\" fill-rule=\"evenodd\"><rect id=\"Rectangle\" transform=\"translate(32.000000, 32.500000) rotate(45.000000) translate(-32.000000, -32.500000) \" x=\"-2\" y=\"31\" width=\"68\" height=\"3\"></rect><rect id=\"Rectangle\" transform=\"translate(32.000000, 32.500000) rotate(135.000000) translate(-32.000000, -32.500000) \" x=\"-2\" y=\"31\" width=\"68\" height=\"3\"></rect></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/close.svg
// module id = srjS
// module chunks = 1